import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";

import AuthLayout from "../authLayout";
import {
  login,
  selectisLoggedIn,
  selectstatus,
} from "../../../store/features/curatorSlice";

const CuratorLogin = () => {
  let dispatch = useDispatch();
  let navigate = useNavigate();

  let loadingStatus = useSelector(selectstatus);
  let isLoggedInStatus = useSelector(selectisLoggedIn);

  const [error, setError] = React.useState("");
  const [showError, setShowError] = React.useState(false);

  const handleSubmit = async ({ userQuery, password }) => {
    if (!userQuery) {
      setError("Enter your user ID");
      setShowError(true);
      return;
    }
    if (!password) {
      setError("Enter your password");
      setShowError(true);
      return;
    }

    let resData = await dispatch(login({ userQuery, password })).unwrap();
    if (resData.statusCode === 200) {
      window.location.href = "/curator/auction";
    } else if (resData.statusCode === 400) {
      setError(resData.msg);
      setShowError(true);
    }
  };

  React.useEffect(() => {
    if (isLoggedInStatus) navigate("/curator/auction");
  }, [isLoggedInStatus]);

  React.useEffect(() => {
    if (loadingStatus === "fulfilled") navigate("/curator/auction");
  }, [loadingStatus]);

  return (
    <AuthLayout
      role="curator"
      blurb="Run the auction room: start a category, take bids, and sell."
      onSubmit={handleSubmit}
      error={error}
      showError={showError}
      setShowError={setShowError}
    />
  );
};

export default CuratorLogin;
